import { PromotionDecision } from '@gongxigames/framework/integrations/rubyplay/types';
import { IPromotionLogicInterface } from '@gongxigames/framework/promotions';

export interface IMultiSetsPromotionInterface extends IPromotionLogicInterface {
    setChoice(choice: PromotionDecision, callback: () => void): void;
    end(): void;
}
